import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { adminApi } from '../api/client';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [username, setUsername] = useState(null);
  const [checking, setChecking] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem('gnc_token');
    if (!token) {
      setUsername(null);
      setChecking(false);
      return;
    }
    try {
      const me = await adminApi.me();
      setUsername(me.username);
    } catch {
      localStorage.removeItem('gnc_token');
      setUsername(null);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (u, p) => {
    const res = await adminApi.login(u, p);
    localStorage.setItem('gnc_token', res.access_token);
    setUsername(res.username);
    return res;
  };

  const logout = () => {
    localStorage.removeItem('gnc_token');
    setUsername(null);
  };

  return (
    <AuthContext.Provider value={{ username, checking, login, logout, isAuthenticated: !!username }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
